import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
export function InvalidValues(props) {
    const { unsupportedAuthenticationMode, unsupportedNameFormat } = props;
    if (!unsupportedAuthenticationMode && !unsupportedNameFormat) {
        return null;
    }
    return (<Fragment>
      {unsupportedAuthenticationMode && (<Alert appearance="warning" title={t({
                comment: 'eSigning invalid authentication mode - Alert title',
                message: 'Invalid authentication mode',
            })} message={t({
                comment: 'eSigning invalid authentication mode - Alert message',
                message: 'At least one signing party has an invalid authentication mode. Please change it to continue.',
            })}/>)}
      {unsupportedNameFormat && (<Alert appearance="warning" title={t({
                comment: 'eSigning invalid name format - Alert title',
                message: 'Invalid name',
            })} message={t({
                comment: 'eSigning invalid name format - Alert message',
                message: 'At least one signing party has an invalid name. Please change it to continue.',
            })}/>)}
    </Fragment>);
}
